import * as authActions from '../actions/auth-actions';

/**
 * @typedef {{accessToken: string | null, userId: number | null, isLoggedIn: boolean}} AuthState - The state of authentication.
 */

/**
 * @type {AuthState}
 */
const initialState = {
  accessToken: null,
  tempToken: null,
  userId: null,
  isLoggedIn: false,
  messages: [],
  pswdResetRequestSend: false,
};

/**
 * @param {AuthState} state - State.
 * @param action - Action.
 */
export default function auth(state = initialState, action) {
  let newState;
  switch (action.type) {
    // If it is a logout success action.
    case authActions.LOGOUT_SUCCESS:
      // Delete auth cookies.
      document.cookie = 'SESSION=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      newState = {
        ...state,
        accessToken: null,
        userId: null,
        isLoggedIn: false,
      };

      return newState;
    case authActions.AUTH_LOGIN_SUCCESS:
      newState = {
        ...state,
        userId: action.payload?.userId,
        isLoggedIn: true,
      };

      return newState;
    // If it is a reset password action.
    case authActions.REQUEST_PASSWORD:
      newState = {
        ...state,
        errors: null,
      };
      return newState;

    // If it is a reset password success action.
    case authActions.REQUEST_PASSWORD_SUCCESS:
      newState = {
        ...state,
        errors: null,
        messages: ['Enviamos um e-mail para você alterar sua senha. VERIFIQUE SUA CAIXA DE SPAM/LIXO ELETRÔNICO'],
        pswdResetRequestSend: true,
      };
      return newState;

    // If it is a reset password success action.
    case authActions.REQUEST_PASSWORD_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
        messages: [],
      };
      return newState;

    // If it is a loginchange password success action.
    case authActions.CHANGE_PASSWORD_SUCCESS:
      newState = {
        ...state,
        isLoggedIn: true,
        errors: null,
        messages: [],
      };
    case authActions.GET_TEMP_TOKEN_SUCCESS:
      newState = {
        ...state,
        tempToken: action.payload?.tempToken
      };
      return newState;
    case authActions.GET_LOGGED_SUCCESS:
      newState = {
        ...state,
        isLoggedIn: action.payload
      };
      return newState;
    default:
      return { ...state };
  }
}
